<div class="uni-datepicker mat-form-field">
  <ng-content></ng-content>
  <uni-icon
    class="uni-datepicker__icon"
    name="calendar-alt"
    (click)="datepicker.open()"
  ></uni-icon>
</div>
